import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

export default function TerminosPage() {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <Link to="/" className={styles.back}>← Volver al inicio</Link>

        <h1 className={styles.title}>Términos y Condiciones de Uso</h1>
        <p className={styles.version}>Versión 1.0 · Septiembre de 2026</p>

        <section>
          <h2>1. Aceptación</h2>
          <p>Al acceder y usar el sitio <strong>news.fenagro-oficial.org</strong>, el usuario acepta estos Términos y Condiciones. Si no está de acuerdo, debe abstenerse de usar el sitio.</p>
        </section>

        <section>
          <h2>2. Descripción del Servicio</h2>
          <p>Comercio Colaborativo es un periódico digital especializado en economía colaborativa, comercio asertivo y redes socio-empresariales. El acceso a la lectura es gratuito. Los servicios de publicidad tienen tarifas establecidas en el tarifario vigente.</p>
        </section>

        <section>
          <h2>3. Propiedad Intelectual</h2>
          <p>Todo el contenido editorial — artículos, fotografías, infografías, diseños — es propiedad de sus respectivos autores y/o de Redeprog/Fenagro, protegido por la Ley 23 de 1982 (Derechos de Autor en Colombia) y convenios internacionales.</p>
          <p>Queda prohibida la reproducción total o parcial sin autorización escrita, excepto para uso personal no comercial con citación de la fuente.</p>
        </section>

        <section>
          <h2>4. Contenido Publicitario</h2>
          <p>El contenido marcado como <em>"Publicidad"</em> o <em>"Contenido Patrocinado"</em> es responsabilidad exclusiva del anunciante. Comercio Colaborativo no garantiza la veracidad de las afirmaciones publicitarias ni se responsabiliza por transacciones entre anunciantes y lectores.</p>
          <p>Los anunciantes declaran que su material cumple con el Estatuto del Consumidor (Ley 1480 de 2011) y que no contiene contenido engañoso, discriminatorio o ilegal.</p>
        </section>

        <section>
          <h2>5. Limitación de Responsabilidad</h2>
          <p>Comercio Colaborativo no se responsabiliza por interrupciones causadas por fuerza mayor, fallas de proveedores de infraestructura o ataques cibernéticos. El servicio se presta "tal como está" sin garantías de disponibilidad continua.</p>
        </section>

        <section>
          <h2>6. Infraestructura y Datos</h2>
          <p>Los datos del sitio se procesan en servidores de Google Cloud Platform ubicados en Estados Unidos. Esta práctica es legal bajo la Ley 1581 de 2012 y cumple con los estándares internacionales de seguridad. Ver nuestra <Link to="/privacidad">Política de Privacidad</Link> para más detalles.</p>
        </section>

        <section>
          <h2>7. Ley Aplicable y Jurisdicción</h2>
          <p>Estos términos se rigen por las leyes de la República de Colombia. Cualquier controversia se someterá a los jueces competentes de la ciudad de <strong>Bucaramanga, Santander, Colombia</strong>, salvo acuerdo de las partes en contrario.</p>
        </section>

        <section>
          <h2>8. Contacto</h2>
          <p>Para cualquier asunto: <a href="mailto:privacidad@fenagro-oficial.org">privacidad@fenagro-oficial.org</a></p>
        </section>

        <div className={styles.links}>
          <Link to="/privacidad">Ver Política de Privacidad →</Link>
        </div>
      </div>
    </div>
  );
}
